import { DataTablePagination } from './data-table-pagination'
import { DataTableRoot } from './data-table-root'
import { DataTableTable } from './data-table-table'
import { DataTableToolbar } from './data-table-toolbar'

const DataTable = Object.assign(
  {},
  {
    Root: DataTableRoot,
    Table: DataTableTable,
    Toolbar: DataTableToolbar,
    Pagination: DataTablePagination,
  }
)

export { DataTable }
export {
  useDataTable,
  useDataTableQuery,
  useDataTableState,
} from './use-data-table'
